import React from 'react';

const LOGIN_URL = process.env.REACT_APP_LOGIN_URL;

const ProtectedRoute = ({ children }) => {
  let accessToken = localStorage.getItem('accessToken');
  if (!accessToken) {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const userId = urlParams.get('userId');
    if (token && userId) {
      localStorage.setItem('accessToken', token);
      localStorage.setItem('userId', userId);
      // Clean up URL (use current pathname for security and flexibility)
      window.history.replaceState({}, document.title, window.location.pathname);
      accessToken = token;
    }
  }

  if (!accessToken) {
    window.location.replace(LOGIN_URL);
    return null;
  }

  return children;
};

export default ProtectedRoute; 